<template>
  <div id="app">
    <localization></localization>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Localization from "@/localization";

export default {
  name: "app",
  components: { Localization },
  computed: {
    ...mapState(["settings"]),
    nextRoute() {
      return this.$route.query.redirect || "/";
    },
  },
  mounted() {
    this.$store.commit("SET_PRIMARY_COLOR", {
      color: this.settings.primaryColor,
    });
    this.$store.commit("SET_THEME", { theme: this.settings.theme });
  },
  methods: {},
  watch: {
    "$store.state.settings.theme"(theme) {
      this.$store.commit("SET_THEME", { theme });
    },
    $route(to, from) {
      const query = Object.assign({}, to.query);
      this.$store.commit("SETUP_URL_SETTINGS", query);
    },
  },
};
</script>
<style>
.ant-modal-mask {
  background-color: rgba(0, 0, 0, 0.45) !important;
}
.container {
  margin-top: 20px;
}

/* body a {
  text-decoration: underline;
} */

.ql-editor {
  min-height: 50px !important;
}

.ant-table-footer {
  padding: 8px 8px !important;
  background: #fff !important;
}

.top-table .ant-table .ant-table-body {
  max-width: 100%;
  overflow-x: auto;
}
</style>
